import { params, executeSearchUrl, displayResults } from '../search-main';
import { URLCriteriaHelper } from '../search-urlcriteriahelper';

const countIcon = document.createElement('span');

document.addEventListener('DOMContentLoaded', () => {
    document.querySelector<HTMLInputElement>('#min-pay')?.addEventListener('keyup', minPayKeyup);
    document.querySelector<HTMLButtonElement>('#apply-min-pay')?.addEventListener('click', applyMinPayFilterClicked);
    document.querySelector<HTMLButtonElement>('#apply-grade-range')?.addEventListener('click', applyGradeRangeFilterClicked);
    document.querySelector<HTMLSelectElement>('#min-grade')?.addEventListener('change', minGradeChanged);
    document.querySelector<HTMLSelectElement>('#max-grade')?.addEventListener('change', maxGradeChanged);
});

export function displayPayFilter() {
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyMinPayButton = document.querySelector<HTMLButtonElement>('#apply-min-pay');
    const applyGradeRangeButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');

    if (minGradeElem === null || maxGradeElem === null || minPayElem === null || applyMinPayButton === null || applyGradeRangeButton === null || params === undefined) {
        return;
    }

    if (params.RemunerationMinimumAmount !== undefined && params.RemunerationMinimumAmount !== null && parseInt(params.RemunerationMinimumAmount ?? "0") > 0) {
        minPayElem.value = params.RemunerationMinimumAmount ?? '';
        applyMinPayButton.disabled = false;
    }

    if (params.GradeBucket?.length === 1) {
        if (params.RemunerationMinimumAmount !== null) {
            minGradeElem.value = params.GradeBucket[0];
            minGradeChanged();
        }
        else if (params.RemunerationMaximumAmount !== null) {
            maxGradeElem.value = params.GradeBucket[0];
            maxGradeChanged();
        }
        params.GradeSearch = true;
        applyGradeRangeButton.disabled = false;
    }
    else if (params.GradeBucket?.length > 1) {
        minGradeElem.value = params.GradeBucket[0];
        minGradeChanged();
        maxGradeElem.value = params.GradeBucket[params.GradeBucket.length - 1];
        maxGradeChanged();
        applyGradeRangeButton.disabled = false;
    }
    const titleElem = document.querySelector<HTMLElement>('#titleaccordion-pay');
    if (titleElem !== null) {
        countIcon.className = params.JobCategoryCode?.length > 0 ? 'bg-warning rounded-full py-1 px-2 ml-2' : 'bg-warning rounded-full py-1 px-2 ml-2 hidden';
        countIcon.innerText = params.JobCategoryCode?.length.toString();
        if (!titleElem.contains(countIcon)) {
            titleElem.appendChild(countIcon);
        }
        setCountIconDisplay();
    }
}

function setCountIconDisplay() {
    if ((params.GradeBucket && params.GradeBucket.length > 0) || (params.RemunerationMinimumAmount !== undefined && params.RemunerationMinimumAmount !== null && params.RemunerationMinimumAmount !== '')) {
        countIcon.innerText = '1';
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }
}

function minPayKeyup(evt: KeyboardEvent) {
    const minPayElem = <HTMLInputElement>(evt.target);
    const applyElem = document.querySelector<HTMLButtonElement>('#apply-min-pay');

    if (minPayElem === null || applyElem === null) {
        return;
    }

    let minPay = new Intl.NumberFormat().format(parseFloat(minPayElem.value.replace(/[^0-9.]/g, "")));

    minPayElem.value = isNaN(parseFloat(minPay)) ? '' : minPay;
    applyElem.disabled = minPayElem.value === '';
}

function minGradeChanged() {
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');

    if (minGradeElem === null || maxGradeElem === null || applyButton === null) {
        return;
    }

    const minGrade = parseInt(minGradeElem.options[minGradeElem.selectedIndex].value) ?? -1;

    Array.from(maxGradeElem.options).forEach(option => {
        if (option.value === '-1') {
            return;
        }
        if (parseInt(option.value) < minGrade) {
            option.classList.add('hidden');
        }
        else {
            option.classList.remove('hidden');
        }
    });
    applyButton.disabled = minGradeElem.selectedIndex < 1 && maxGradeElem.selectedIndex < 1;
}

function maxGradeChanged() {
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');
    if (minGradeElem === null || maxGradeElem === null || applyButton === null) {
        return;
    }

    const maxGrade = parseInt(maxGradeElem.options[maxGradeElem.selectedIndex].value) ?? -1;

    Array.from(minGradeElem.options).forEach(option => {
        if (option.value === '-1') {
            return;
        }
        if (parseInt(option.value) > maxGrade) {
            option.classList.add('hidden');
        }
        else {
            option.classList.remove('hidden');
        }
    });

    applyButton.disabled = minGradeElem.selectedIndex < 1 && maxGradeElem.selectedIndex < 1;
}

function applyMinPayFilterClicked() {
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const gradeApplyButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');

    if (minPayElem === null || isNaN(parseInt(minPayElem.value)) || minGradeElem === null || maxGradeElem === null || gradeApplyButton === null) {
        return;
    }
    params.GradeSearch = false;
    params.GradeBucket = [];
    params.RemunerationMaximumAmount = null;
    params.RemunerationMinimumAmount = minPayElem.value.replace(/[,]/g, '');
    minGradeElem.selectedIndex = 0;
    maxGradeElem.selectedIndex = 0;
    gradeApplyButton.disabled = true;
    params.Page = '1';

    setCountIconDisplay();
    displayResults(executeSearchUrl, false, true);
    URLCriteriaHelper.reconstructUrl();
}

function applyGradeRangeFilterClicked() {
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const minPayApplyButton = document.querySelector<HTMLButtonElement>('#apply-min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');

    if (minGradeElem === null || maxGradeElem === null || minPayElem === null || minPayApplyButton === null) {
        return;
    }
    const minGrade = parseInt(minGradeElem.value) ?? -1;
    const maxGrade = parseInt(maxGradeElem.value) ?? -1;

    params.GradeBucket = [];
    params.RemunerationMinimumAmount = null;
    params.RemunerationMaximumAmount = null;
    minPayElem.value = '';
    minPayApplyButton.disabled = true;

    if (minGrade === -1 && maxGrade === -1) {
        return;
    }
    else if (minGrade === -1) {
        params.GradeBucket = [...Array(maxGrade + 1).keys()].map(i => i.toString());
    }
    else if (maxGrade === -1) {
        params.GradeBucket.push(minGradeElem.value);
    }
    else {
        params.GradeBucket = [...Array(maxGrade - (minGrade - 1)).keys()].map(i => (i + minGrade).toString());
    }

    if (minGradeElem.selectedIndex > 0) {
        params.RemunerationMinimumAmount = minGradeElem.options[minGradeElem.selectedIndex].getAttribute('data-salary');
    }
    if (maxGradeElem.selectedIndex > 0) {
        params.RemunerationMaximumAmount = maxGradeElem.options[maxGradeElem.selectedIndex].getAttribute('data-salary');
    }

    params.GradeSearch = true;
    params.Page = '1';
    setCountIconDisplay();
    displayResults(executeSearchUrl, false, true);
    URLCriteriaHelper.reconstructUrl();
}
